import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogActions, MatDialogClose, MatDialogContent, MatDialogModule, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { DeleteReportDialogResult } from '../../../models/reports/DeleteReportDialogResult';

@Component({
  selector: 'app-delete-report-dialog',
  imports: [
    TranslatePipe,
    MatDialogModule,
    MatButtonModule,
    MatDialogActions,
    MatDialogClose,
    MatDialogTitle,
    MatDialogContent
  ],
  templateUrl: './delete-report-dialog.component.html',
  styleUrl: './delete-report-dialog.component.scss'
})
export class DeleteReportDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<DeleteReportDialogComponent>
  ) {}

  onYesClick(): void {
    const result: DeleteReportDialogResult = { confirmed: true };
    this.dialogRef.close(result);
  }
}